import { render, staticRenderFns } from "./ImageUploadModal.vue?vue&type=template&id=3bf80f04"
import script from "./ImageUploadModal.vue?vue&type=script&lang=ts"
export * from "./ImageUploadModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ImageUploadModal.vue?vue&type=custom&index=0&blockType=stype&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports